import React from "react";
import { ArrowLeft, Clock, Loader, RefreshCw } from "lucide-react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

export const ConnectionHeader = ({
    connector,
    connectionName,
    syncSchedule,
    dataSource,
    syncing,
    triggerSync
}) => {
    const navigate = useNavigate();

    return (
        <div className="bg-white border-b border-gray-200">
            <div className="max-w-7xl mx-auto px-4 py-4">
                <button
                    onClick={() => navigate("/connectors")}
                    className="flex items-center text-gray-500 hover:text-gray-700 mb-4"
                >
                    <ArrowLeft className="w-4 h-4 mr-2" />
                    Back to Connectors
                </button>

                <div className="flex items-center justify-between">
                    <div className="flex items-center">
                        {connector?.iconUrl && (
                            <img
                                src={connector.iconUrl}
                                alt={connector.name}
                                className="w-10 h-10 mr-3 rounded"
                            />
                        )}
                        <div className="flex flex-col">
                            <h1 className="text-xl font-bold text-gray-900 leading-none mb-2">
                                {connectionName}
                            </h1>
                            <div className="flex items-center text-sm text-gray-500">
                                <div className="flex items-center">
                                    {connector?.iconUrl && (
                                        <img
                                            src={connector.iconUrl}
                                            alt={connector.name}
                                            className="w-4 h-4 mr-1 rounded-sm"
                                        />
                                    )}
                                    <span>{connectionName}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex items-center gap-4">
                        <div className="flex items-center mr-4">
                            <Clock className="w-4 h-4 text-gray-400 mr-2" />
                            <span className="text-sm text-gray-500 mr-4">{syncSchedule === 'manual' ? 'Manual' : syncSchedule}</span>

                            <label className="relative inline-flex items-center cursor-pointer">
                                <input type="checkbox" className="sr-only peer" checked={dataSource?.status === 'active'} onChange={() => {
                                    toast.success('To disable, use Settings tab');
                                }} disabled />
                                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                                <span className="ml-3 text-sm font-medium text-gray-900">{dataSource?.status === 'active' ? 'ENABLED' : 'DISABLED'}</span>
                            </label>
                        </div>

                        {syncing && (
                            <button
                                className="text-red-600 text-sm font-medium hover:text-red-700 px-3"
                                onClick={() => toast.error('Cancelling sync is not supported yet')}
                            >
                                Cancel Sync
                            </button>
                        )}
                        <button
                            onClick={triggerSync}
                            disabled={syncing || !dataSource?.airbyteConnectionId}
                            className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:bg-gray-400 flex items-center"
                        >
                            {syncing ? (
                                <>
                                    <Loader className="w-4 h-4 mr-2 animate-spin" />
                                    Syncing...
                                </>
                            ) : (
                                <>
                                    <RefreshCw className="w-4 h-4 mr-2" />
                                    Sync now
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
